import { Instance } from "../../Base";
import Decorator from "../Decorator";

export default class AbroadConsentConfirmDecorator extends Decorator {
  constructor(component: Instance) {
    super(component);

    const abroadConsentCheckbox =
      component.element.querySelector("input");

    if (!abroadConsentCheckbox) return;

    abroadConsentCheckbox.addEventListener("click", (element: any) => {
      const abroadConsentRejectCheckboxes: any = Array.from(document.querySelectorAll("[id^='rejectAbroadConsent']"));
      if (element.target.checked === true) {
        abroadConsentRejectCheckboxes.forEach((el: any) => {
          if (el.id !== element.target.id) {
            el.checked = false;
          }
        });
      } else {
        abroadConsentRejectCheckboxes.forEach((el: any) => {
          if (el.id === element.target.id) {
            el.checked = false;
          }
        });
      }
    });
  }
}